import React from "react";
import Button from "react-bootstrap/Button";
import Shape from '../images/Shape.png';
import Rectangle from '../images/Rectangle.png';
import RectangleBlue from '../images/RectangleBlue.png';
import Profile from '../images/Profile.png';
import { Link } from 'react-router-dom';
import Footer from "./reusable-components/footer";

function register() {
  return (
    <div className="App"
      style={{
        width: '100%',
        height: '753px',
        backgroundColor: '#FFFFFF',
        textAlign: 'center'
      }}>
      <div className="topBar"
        style={{ padding: '13px' }}>
        <img src={Shape} style={{ width: '65px', height: '17px' }} alt="" />
      </div>
      <div >
        <img src={Rectangle} style={{ width: '100%', height: '66px' }} alt="" />
      </div>
      <div className="thanks"
        style={{
          width: '100%',
          height: '91px',
          textAlign: 'center',
          backgroundImage: `url(${RectangleBlue})`
        }}>
        <p
          style={{
            fontFamily: 'Sintony',
            padding: '15px',
            textAlign: 'center',
            color: '#FFFFFF'
          }}>
          Thanks, Shawn.<br></br>
          You are now registered with IQOS.
        </p>
      </div>
      <div>
        <img src={Profile} style={{ width: '194px', height: '183px', borderRadius: '50%', padding: '15px' }} alt="" />
      </div>
      <div style={{
        fontFamily: 'Sintony',
        textAlign: 'left',
        marginLeft: '20px',
        marginRight: '20px'
      }}>
        <span style={{
          color: '#2689D5',
          fontSize: '14px'
        }}
        >Meet Your IQOS Expert</span>
        <p style={{
          fontSize: '13px',
        }}>
          My name is Lana, and I will be guiding you through your IQOS journey. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eius lorem mod tempor incididunt ut labore et dolore sit magna aliqua. Ut enim ad minim veniam.
        </p>
      </div>
      <div style={{
        fontFamily: 'Sintony',
        textAlign: 'left',
        marginLeft: '20px',
        marginRight: '20px'
      }}>
        <span
          style={{
            fontSize: '14px',
            color: '#2689D5'
          }}>
          How to Work with Your Expert
        </span>
        <p
          style={{
            fontSize: '13px'
          }}>
          Duis aute irure dolor in repreh derit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non pro dsident, sunt in culpa qui officia deserunt mollit anim id est laborum lorem ipsum doler.
        </p>
        <div style={{
          fontFamily: 'Sintony',
          textAlign: 'left'
        }}>
          <span
            style={{
              fontSize: '14px',
              color: '#2689D5'
            }}>
            The IQOS Journey
          </span>
          <p
            style={{
              fontSize: '13px'
            }}>
            Duis aute irure dolor in repreh derit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non pro dsident, sunt in culpa qui officia deserunt mollit anim id est laborum lorem ipsum doler.
            <br></br><br></br>
            If you're ready, let's get started!
          </p>
        </div>
      </div>
      <div
        style={{
          padding: '13px'
        }}>
        <Link to="/get-started ">
          <Button variant="success" size="lg" type="submit" style={{
            height: '35px',
            width: '153px',
            fontSize: '12px',
            fontWeight: 'bold',
            borderRadius: '0',
            color: '#FFFFFF',
            backgroundColor: '#00A78A'
          }}>
            GET STARTED
          </Button>
        </Link>
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
}

export default register;